import { api } from '@api'
import {
  Contracts,
  ContractFilters,
  ContractsFilterResponse,
  ContractsAsnumsResponse,
  OrderContract,
  OrdersResponse,
  OrdersFilters,
} from '@types'

const base = '/sap-items'

interface GetContractsResponse {
  contracts: Contracts
}

type Params = {
  filters?: ContractFilters | OrdersFilters
}

type OrdersParams = {
  filters?: OrdersFilters
}

const getContracts = async (params: Params) => {
  const { filters } = params
  const response = await api.get<GetContractsResponse>(base, {
    params: {
      ...filters,
    },
  })

  return response.data.contracts
}

const getContractsFilter = async (params: Params) => {
  const { filters } = params
  const response = await api.get<ContractsFilterResponse>(base + '/filters', {
    params: filters,
  })

  return response.data
}

const getAsnums = async (params: Params) => {
  const { filters } = params
  const response = await api.get<ContractsAsnumsResponse>(base + '/asnums', {
    params: filters,
  })

  return response.data
}

const getOrders = async (params: OrdersParams) => {
  const { filters } = params
  const { carrierId, contract, orderNumber, page, limit, ...restFilters } = filters || {}

  const paramsToSend: any = {
    page,
    limit,
    ...restFilters,
  }

  if (carrierId) {
    if (Array.isArray(carrierId)) {
      paramsToSend.carrierId = carrierId
    } else {
      paramsToSend.carrierId = [carrierId]
    }
  }

  if (contract) {
    paramsToSend.contract = contract
  }

  if (orderNumber) {
    paramsToSend.orderNumber = orderNumber
  }

  const response = await api.get<OrdersResponse>(base + '/order', {
    params: paramsToSend,
  })
  return response.data
}

interface UpdateOrderParams {
  id: number
  payload: Partial<OrderContract>
}

const updateOrder = async ({ id, payload }: UpdateOrderParams) => {
  const response = await api.patch<any>('carriers/contract-order/' + id, payload)

  return response.data
}

export const ContractsApi = { getContracts, getContractsFilter, getAsnums, getOrders, updateOrder }
